import { CreatedBy } from "./created-by";

export class Attachment {

    id: number;
    description: string;
    path: string; //"1487763469.4324.txt"
    created_at: Date; 
    created_by: CreatedBy;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/models/attachment.ts